// User API endpoints (RTK Query)
import baseApi, { apiTags } from '../api/baseApi'

const userApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    fetchUserList: builder.query({
      providesTags: [apiTags.USER_LIST],
      query: () => 'user',
    }),

    fetchUserById: builder.query({
      query: id => `user/${id}`,
    }),

    createUser: builder.mutation({
      invalidatesTags: [apiTags.USER_LIST],
      query: body => ({
        body,
        method: 'POST',
        url: 'user',
      }),
    }),

    fetchUserRolesList: builder.query({
      providesTags: [apiTags.USER_ROLES_LIST],
      query: () => 'user/roles/list',
    }),

    fetchModulesList: builder.query({
      query: () => 'app/module',
    }),

    fetchLaboratoriesList: builder.query({
      query: () => 'app/laboratory',
    }),

    fetchSurveyCompaniesList: builder.query({
      query: () => 'app/survey_company',
    }),

    updateUser: builder.mutation({
      invalidatesTags: [apiTags.USER_LIST],
      query: ({ id, ...body }) => ({
        body,
        method: 'PUT',
        url: `user/${id}`,
      }),
    }),

    resetUserPassword: builder.mutation({
      query: id => ({
        method: 'POST',
        url: `user/${id}/reset-password`,
      }),
    }),
  }),
})

export const {
  useCreateUserMutation,
  useResetUserPasswordMutation,
  useUpdateUserMutation,
  useFetchUserByIdQuery,
  useFetchUserListQuery,
  useFetchUserRolesListQuery,
  useFetchModulesListQuery,
  useFetchLaboratoriesListQuery,
  useFetchSurveyCompaniesListQuery,
  useLazyFetchUserByIdQuery,
} = userApi

export default userApi
